import { cn } from "@/lib/utils";

export const SWIFT_LOGO_PATH = "/swiftlogooo.svg";

type SwiftLogoProps = {
  className?: string;
  priority?: boolean;
};

/** Full wordmark - `/public/swiftlogooo.svg` (106×23). */
export function SwiftLogo({ className }: SwiftLogoProps) {
  return (
    <img
      src={SWIFT_LOGO_PATH}
      alt="Swift MVP"
      width={106}
      height={23}
      className={cn("h-auto w-auto max-w-full object-contain", className)}
    />
  );
}
